import React from 'react';

import { IconProps } from '../../IconsProps';

import './index.scss';

const EditRowIcon: React.FC<IconProps> = () => (
  <svg
    id='Edit_Row_Dark_Theme_'
    data-name='Edit Row (Dark Theme)'
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    className='parent-Edit-Table'
  >
    <rect id='Margin_Rectangle' data-name='Margin Rectangle' className='edit-table-cls1' width='32' height='32' />
    <path id='Base' className='edit-table-cls2' d='M0,0H16V1H0Z' transform='translate(8 22.981)' />
    <g id='Pencil' className='edit-table-cls3' transform='translate(-3 0.981)'>
      <path className='edit-table-cls4' d='M22.5,12.011,20,9.515,13.01,16.5,12,20.01,15.507,19Z' />
      <path
        className='edit-table-cls5'
        d='M 19.99909019470215 10.92910575866699 L 13.89998817443848 17.02826881408691 L 13.46191787719727 18.54856872558594 L 14.98216819763184 18.11056900024414 L 21.08137512207031 12.0113639831543 L 19.99909019470215 10.92910575866699 M 19.99908256530762 9.514894485473633 L 22.49560165405273 12.01135444641113 L 15.50689315795898 19.00006484985352 L 12.00000190734863 20.01043510437012 L 13.01050186157227 16.50354385375977 L 19.99908256530762 9.514894485473633 Z'
      />
    </g>
    <g id='Rubber' className='edit-table-cls3' transform='translate(19.496 8) rotate(45)'>
      <path className='edit-table-cls4' d='M1,0H2.531a1,1,0,0,1,1,1V3.531H0V1A1,1,0,0,1,1,0Z' />
      <path
        className='edit-table-cls5'
        d='M 0.9999954700469971 1.000001192092896 L 0.9999954700469971 2.530541181564331 L 2.530555248260498 2.530541181564331 L 2.530555248260498 1.000001192092896 L 0.9999954700469971 1.000001192092896 M 0.9999954700469971 1.192092895507812e-06 L 2.530555248260498 1.192092895507812e-06 C 3.08283543586731 1.192092895507812e-06 3.530555248260498 0.4477112293243408 3.530555248260498 1.000001192092896 L 3.530555248260498 3.530541181564331 L -4.529953002929688e-06 3.530541181564331 L -4.529953002929688e-06 1.000001192092896 C -4.529953002929688e-06 0.4477112293243408 0.4477152824401855 1.192092895507812e-06 0.9999954700469971 1.192092895507812e-06 Z'
      />
    </g>
  </svg>
);

export default EditRowIcon;
